// GzEdN — essay table-of-contents.
// Populates the sticky .essay-toc sidebar from the article's <h2> headings
// and turns each entry into an anchor link.
document.addEventListener('DOMContentLoaded', function () {
    var toc = document.querySelector('aside.essay-toc[data-essay-toc]');
    if (!toc) return;

    var article = document.querySelector('.essay-article');
    if (!article) return;

    var list = toc.querySelector('ol');
    if (!list) return;

    var headings = article.querySelectorAll('h2');
    if (!headings.length) return;

    headings.forEach(function (heading, index) {
        var num = String(index + 1).padStart(2, '0');

        if (!heading.id) {
            heading.id = 'sec-' + num;
        }

        var li = document.createElement('li');

        var n = document.createElement('span');
        n.className = 'n';
        n.textContent = num;

        var a = document.createElement('a');
        a.href = '#' + heading.id;
        a.textContent = heading.textContent;

        li.appendChild(n);
        li.appendChild(a);
        list.appendChild(li);
    });
});
